import { render } from "./MailingBlockTitle.vue?vue&type=template&id=afc7d19a"
import script from "./MailingBlockTitle.vue?vue&type=script&lang=js"
export * from "./MailingBlockTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__